// extracted by mini-css-extract-plugin
module.exports = {"mediaContainer":"featureItem_mediaContainer__8610c","playBtnContainer":"featureItem_playBtnContainer__DGHR7","playBtn":"featureItem_playBtn__WYDbM"};